import React from 'react'
import ReactLoading from 'react-loading'

export default function Loading() {
    return (
        <div style={{position:'fixed', width:'50px',
         top:'calc(50vh - 25px)',
         right:'calc(50vw - 25px)'
         }}>
            
        <ReactLoading
         type={'spin'} color={'white'} 
         height={'50px'} width={'50px'}
         />
         </div>

    )
}
